var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "user-con"
  }, _vm._l([1, 2, 3], function (item) {
    return _c("div", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("user");
        }
      }
    }, [_vm._m(0, true), _c("div", {
      staticClass: "follow"
    }, [_vm._v(_vm._s(_vm.$t("Follow")))])]);
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "left"
  }, [_c("img", {
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/sns_bg.png",
      alt: ""
    }
  }), _c("span", [_vm._v("New Energy")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };